import React from "react";
import Media from "@qlik/qlik/src/components/Media";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import Cta from "@qlik/qlik/src/components/Cta";
import * as styles from "./styles.module.css";

const GartnerCards = ({ data }) => {
    const { additionalConfiguration, title, description, cardItems = [], customId } = data ?? {};
    const spacingClassName = getSpacingClassName(additionalConfiguration);
    return (
        <section className={`${spacingClassName} gartner-cards`} id={customId}>
            <div className="container">
                {title && <h2 className="mb-5 title-2 text-left lg:text-center lg:tracking-tight10 "> {title}</h2>}

                {description?.description && (
                    <div className="text-center flex justify-center">
                        <p className="text-sm md:text-md tracking-tight1-l font-normal lg:font-normal lg:tracking-tight6 text-left lg:text-center lg:text-2xl md:leading-relaxed  ">
                            {description?.description}
                        </p>
                    </div>
                )}
                <div className="card-wrapper flex flex-col xl:flex-row justify-between mt-15.25 md:mt-[78px] lg:mt-20 gap-15 xl:gap-7.5 flex-wrap">
                    {cardItems?.map((card) => (
                        <div
                            key={card?.id}
                            style={{
                                backgroundImage:
                                    card?.media?.length > 0
                                        ? `url(${card?.media?.[1]?.desktopMedia?.[0]?.secure_url})`
                                        : "none",
                            }}
                            className={`${styles.cardItem} xl:w-[calc(50%-30px)] max-lg:!bg-none lg:bg-contain md:bg-center lg:bg-right-center bg-no-repeat  `}
                        >
                            {card?.cta?.[0] && (
                                <Cta
                                    data={card?.cta?.[0]}
                                    className={` cardItem card rounded shadow flex gap-7.5 lg:gap-0 flex-col-reverse lg:flex-row hover:no-underline hover:cursor-pointer h-full`}
                                >
                                    <div className="content relative w-full lg:w-3/4 xl:w-[343px] p-5 pb-22.25 lg:p-10 lg:!pb-[134px]">
                                        {card.title && <h2 className="title-3 ">{card.title}</h2>}

                                        {card?.cta?.[0] && (
                                            <span className="btn-secondary-small absolute bottom-10 button mt-7.5 lg:mt-[55px]">
                                                {card.cta[0]?.text}
                                            </span>
                                        )}
                                    </div>
                                    <div
                                        style={{
                                            backgroundImage:
                                                card?.media?.length > 0
                                                    ? `url(${card?.media?.[1]?.mobileMedia?.[0]?.secure_url})`
                                                    : "none",
                                        }}
                                        className={` ${styles.cardMedia} lg:!bg-none truncate cardMedia flex items-center justify-center lg:justify-end grow bg-center bg-no-repeat p-2.75 lg:p-0`}
                                    >
                                        {card?.media?.[0] && (
                                            <Media
                                                media={card?.media?.[0]}
                                                className="max-w-[165px] lg:max-w-55.5 lg:max-h-[222px] lg: w-55.5 h-auto"
                                            />
                                        )}
                                    </div>
                                </Cta>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default GartnerCards;
